import Vue from 'vue'
import Router from 'vue-router'
import { routes } from '@/router/module/index'

Vue.use(Router)
const VueRouterPush=Router.prototype.push
Router.prototype.push=function push(to){
	return VueRouterPush.call(this,to).catch(err=>err)
}

let router = new Router({
	//mode: 'history',  //去掉url中的#
    routes: [...routes]
})
router.beforeEach((to, from, next) => {
    next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js